var map = {
	"./alert.svg": "f262",
	"./availability-downtimes.svg": "cca0",
	"./bar-chart-view.svg": "4926",
	"./calendar-item.svg": "5a16",
	"./downtime-planned.svg": "8f8e",
	"./downtime-unplanned.svg": "1482",
	"./factory.svg": "ae34",
	"./graph.svg": "169c",
	"./insights.svg": "5b2a",
	"./line-chart-view.svg": "cc19",
	"./quantity.svg": "a1c7",
	"./shift-change.svg": "0f9f",
	"./table-view.svg": "7117"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2a93";